import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@coolblue-development/freddy';
import { Video } from '@coolblue-development/next-chat/client';
import { useEffect, useRef, useState } from 'react';
const videoDimensions = {
    height: '96px',
    width: '96px',
};
export function AvatarVideo({ idleVideoSources, introVideoSources, onIntroVideoEnd }) {
    const [hasIntroVideoEnded, setHasIntroVideoEnded] = useState(false);
    const idleVideoRef = useRef(null);
    // Browsers automatically defer loading of non-autoplay and hidden videos,
    // so we need to force it to preload
    useEffect(() => {
        if (idleVideoRef.current) {
            idleVideoRef.current.load();
        }
    }, []);
    const handleIntroVideoEnd = () => {
        if (idleVideoRef.current) {
            idleVideoRef.current
                .play()
                .then(() => {
                setHasIntroVideoEnded(true);
                onIntroVideoEnd();
            })
                .catch(() => {
                onIntroVideoEnd();
            });
        }
        else {
            onIntroVideoEnd();
        }
    };
    return (_jsxs(Box, { sx: { position: 'relative', height: videoDimensions.height, width: videoDimensions.width }, children: [!hasIntroVideoEnded && (_jsx(Box, { sx: { position: 'absolute', top: 0, left: 0 }, children: _jsx(Video, { height: videoDimensions.height, width: videoDimensions.width, loop: false, sources: introVideoSources, onVideoEnd: handleIntroVideoEnd }) })), _jsx(Box, { sx: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    visibility: hasIntroVideoEnded ? 'visible' : 'hidden',
                }, children: _jsx(Video, { height: videoDimensions.height, width: videoDimensions.width, autoPlay: false, sources: idleVideoSources, videoRef: idleVideoRef }) })] }));
}
//# sourceMappingURL=AvatarVideo.js.map